import ax from '../axios'
import { ICurriculumDetail, ID } from "../../constants";
import {API_URL} from "../index";

const CURRICULUM_DETAIL_URL = API_URL.EDUCATION_MODULE + '/curriculum-detail'

const getCurriculumDetails = (query: string) => {
    return ax.get(`${CURRICULUM_DETAIL_URL}?${query}`)
}

const getCurriculumDetailById = (id: ID) => {
    return ax.get(`${CURRICULUM_DETAIL_URL}/${id}`)
}

const createCurriculumDetail = (baseModel: ICurriculumDetail) => {
    delete baseModel.id
    return ax.post(CURRICULUM_DETAIL_URL, baseModel)
}

const updateCurriculumDetail = (baseModel: ICurriculumDetail) => {
    const id = baseModel.id
    delete baseModel.id
    return ax.put(`${CURRICULUM_DETAIL_URL}/${id}`, baseModel)
}

const deleteCurriculumDetail = (id: ID) => {
    return ax.delete(`${CURRICULUM_DETAIL_URL}/${id}`)
}

export {
    createCurriculumDetail,
    getCurriculumDetailById,
    deleteCurriculumDetail,
    getCurriculumDetails,
    updateCurriculumDetail
}
